<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mt-">
                        <label style="font-size: 20px;">Booking Change Options</label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <p>Please Pick the changes we have done in the booking</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <template v-for="item in bookingChangeReasons">
                            <div class="col-md-4" :key="item.value">
                                <div class="form-check">
                                  <label class="form-check-label">
                                    <input type="checkbox" class="form-check-input" :value="item.value" v-model="selectedChangeReasons">
                                    {{ item.value }}
                                  </label>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-4">
                    <button class="button mt-1" @click="sendEmail"><span> {{ buttonText }} </span></button>
                </div>
            </div>
        </div>
      </div>
</template>

<script>
export default {
    name: 'ChangeReasonModal',
    props: {
        buttonText:String,
        bookingChangeReasons: {
            type: Array,
            default:null
        }
    },
    data() {
        return {
            selectedChangeReasons:[]
        }
    },
    methods: {
        sendEmail() {
            this.$emit('triggerEmail',this.selectedChangeReasons)
        }
    }        
}
</script>

<style lang="scss" scoped>

</style>